export const SET_LOADING = 'SET_LOADING'
export const SET_LOADING_CHART = 'SET_LOADING_CHART'
export const SET_IS_PC = 'SET_IS_PC'
export const SET_IS_SIDEBAR_COLLAPSED = 'SET_IS_SIDEBAR_COLLAPSED'

export const SET_VISIBLE_USER_OFFCANVAS_MENU = 'SET_VISIBLE_USER_OFFCANVAS_MENU'
